import React, { useContext, Fragment } from 'react'

import MapLayersContext from 'tripPlanner/contexts/MapLayers/MapLayersContext'
import Heading from 'components/Luxkit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'components/Luxkit/Divider'
import { rem } from 'polished'
import styled from 'styled-components'
import ListItem from 'components/Luxkit/List/ListItem'
import CheckboxButton from 'components/Luxkit/Checkbox/CheckboxButton'

const DividerContainer = styled.div`
  padding-block: ${rem(12)};
`

const SubDividerContainer = styled.div`
  padding-inline: ${rem(16)};
`

function MapLayersOptions() {
  const { layerGroups, toggleLayer, toggleGroup } = useContext(MapLayersContext)

  return (
    <>
      {layerGroups.map((group, i) => <Fragment key={group.id}>
        {i > 0 && <DividerContainer><Divider kind="primary" /></DividerContainer>}
        <VerticalSpacer gap={8}>
          <Heading variant="heading6" colour="neutral-three">{group.title}</Heading>
          <div>
            {group.layers.length > 1 && !!group.selectAllLabel && <>
              <ListItem
                title={group.selectAllLabel}
                onClick={() => toggleGroup(group.id)}
                endIcon={<CheckboxButton checked={group.selectionStatus === 'all'} indeterminate={group.selectionStatus === 'some'} />}
              />
              <SubDividerContainer><Divider kind="primary" /></SubDividerContainer>
            </>}
            {group.layers.map((layer) => {
              const Icon = layer.icon
              return <ListItem
                key={`${group.id}-${layer.id}`}
                title={layer.title}
                startIcon={Icon ? <Icon /> : undefined}
                onClick={() => toggleLayer(group.id, layer.id)}
                endIcon={<CheckboxButton checked={layer.isSelected} />}
              />
            })}
          </div>
        </VerticalSpacer>
      </Fragment>)}
    </>
  )
}

export default MapLayersOptions
